import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { ScreenTrackingService } from '@angular/fire/analytics';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAnalyticsModule } from '@angular/fire/compat/analytics';
import { provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router, TitleStrategy } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import * as sentry from '@sentry/angular-ivy';
import { AngularQueryDevtools } from '@tanstack/angular-query-devtools-experimental';
import { provideAngularQuery, QueryClient } from '@tanstack/angular-query-experimental';
import { provideNgxWebstorage, withLocalStorage, withSessionStorage } from 'ngx-webstorage';
import { DialogService } from 'primeng/dynamicdialog';
import { AppInitializerService, WokapTitleStrategy } from '@/common/services';
import { TranslationLoader } from '@/modules/i18n/translation.loader';
import { AuthenticationInterceptor } from '@/pages/auth/interceptors/authentication.interceptor';
import { environment } from '@environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';

function initializeApp(appInitializerService: AppInitializerService) {
  return () => appInitializerService.initializeApp();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    LayoutModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslationLoader,
      },
      useDefaultLang: true,
      defaultLanguage: 'es',
    }),
    AngularQueryDevtools,
    BrowserAnimationsModule,
    environment.enableMetrics ? [
      AngularFireModule.initializeApp(environment.firebase),
      AngularFireAnalyticsModule,
    ] : [],
  ],
  providers: [
    DialogService,
    environment.enableMetrics ? [ScreenTrackingService] : [],
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true,
    },
    provideNgxWebstorage(
      withLocalStorage(),
      withSessionStorage(),
    ),
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
    environment.enableMetrics ? [
      {
        provide: ErrorHandler,
        useValue: sentry.createErrorHandler({ showDialog: true }),
      },
      {
        provide: sentry.TraceService,
        deps: [Router],
      },
      {
        provide: APP_INITIALIZER,
        useFactory: () => () => {
        },
        deps: [sentry.TraceService],
        multi: true,
      },
    ] : [],
    provideAngularQuery(new QueryClient()),
    provideClientHydration(),
    {
      provide: TitleStrategy,
      useClass: WokapTitleStrategy,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppInitializerService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {

}
